import { render } from "./Edit25Liquidation1.vue?vue&type=template&id=3d878789"
import script from "./Edit25Liquidation1.vue?vue&type=script&lang=js"
export * from "./Edit25Liquidation1.vue?vue&type=script&lang=js"

import "./Edit25Liquidation1.vue?vue&type=style&index=0&id=3d878789&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__